import { render } from "./VaPageNotFound.vue?vue&type=template&id=51e3af20"
import script from "./VaPageNotFound.vue?vue&type=script&lang=js"
export * from "./VaPageNotFound.vue?vue&type=script&lang=js"

import "./VaPageNotFound.vue?vue&type=style&index=0&id=51e3af20&lang=scss"
script.render = render

export default script